import {
  BuildSimpleExtractedFieldDto,
  BuildSimpleExtractedTableRowDto,
} from '../models/build-simple-model';
import { entries, maxBy } from '@ps-gui/shared-utils';

/**
 * Build simple omits every field it did not extract, and the per-class mappers in `service/api`
 * hand us rows whose members can be incomplete. `BuildSimpleExtractedTableRowDto.members` does not
 * express that, so everything deriving geometry from a row has to go through these accessors -
 * otherwise a single partially extracted row takes down the whole batch load.
 */
export const getLocatedMemberEntries = (
  row: BuildSimpleExtractedTableRowDto,
): [string, BuildSimpleExtractedFieldDto][] =>
  entries(row.members).filter(([_, field]) => field?.location !== undefined);

export const getLocatedMembers = (
  row: BuildSimpleExtractedTableRowDto,
): BuildSimpleExtractedFieldDto[] => getLocatedMemberEntries(row).map(([_, field]) => field);

/**
 * The lower bound of a row, i.e. the largest lower offset of its located members.
 * `undefined` for a row without any position - such a row cannot contribute a table line.
 */
export const getRowLowerOffset = (row: BuildSimpleExtractedTableRowDto): number | undefined =>
  maxBy(getLocatedMembers(row), (field) => field.location.lower)?.location.lower;

/**
 * The page a row sits on, taken from its first located member. Rows spanning two pages do not
 * exist in build simple results.
 */
export const getRowPage = (row: BuildSimpleExtractedTableRowDto): number | undefined =>
  getLocatedMembers(row)[0]?.location.page;
